import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=9bf24e40&scoped=true"
import script from "./CompaniesTable.vue?vue&type=script&lang=js"
export * from "./CompaniesTable.vue?vue&type=script&lang=js"
import style0 from "./CompaniesTable.vue?vue&type=style&index=0&id=9bf24e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf24e40",
  null
  
)

export default component.exports